import React , {Component} from 'react';
import AppUtils from '../../apputils';
import { GetToursList } from '../../models/tour';
import { PnkConnect } from '../../pnk-react/pnk-miniredux';
import TravelPage from './travel';


class travel extends Component{
    constructor(){
        super()
        this.state = {
            getTours:true,
            tourlist:[]
        }
    }

    HandleRouting = (route) => {
        AppUtils.HandlePageClick(this.props.componentprops, route)
    }


    HandleGetToursListSuccessResponse = (res)=>{

        if(res !== false){
            console.log(res.data.tourslist.rows)

            this.setState({
                tourlist:res.data.tourslist.rows,
                getTours:false
            })
        }

        else{
            this.setState({
                getTours:false
            })
        }

    }

    render(){
        return(
            <div>
            <TravelPage {...this.props} mystate={this.state} HandleRouting={this.HandleRouting}/>
            {((this.state.getTours === true) ? GetToursList(this.props.PnkStore, this.HandleGetToursListSuccessResponse) : "")}
            </div>
        )
    }
}

export const Travel = PnkConnect(travel , '');